import styled from "styled-components";

export const WalletFundingModalWrapper = styled.div(() => {
  return {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    backgroundColor: "#ffffff",
    borderRadius: "14px",
    width: "480px",
    maxWidth: "calc(100vw - 32px)",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "28px",
    ".wfm-paystack-wrapper": {
      display: "flex",
    },
    ".wfm-paystack-button": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "20px",
      color: "#ffffff !important",
      backgroundColor: "var(--color-primary, #2e7d32) !important",
      border: "1px solid var(--color-primary, #2e7d32) !important",
      borderRadius: "8px",
      padding: "0 20px",
      height: "44px",
      width: "100%",
      cursor: "pointer",
      display: "flex !important",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      transition: "background-color 0.15s ease, transform 0.15s ease",
      "&:hover": {
        backgroundColor: "#256427 !important",
      },
      "&:active": {
        transform: "scale(0.98)",
      },
    },
  };
});

export const ModalHeader = styled.div(() => {
  return {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "12px",
    ".wfm-header-text": {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    ".wfm-title": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 700,
      fontSize: "20px",
      lineHeight: "28px",
      color: "var(--color-text, #333333)",
      margin: 0,
    },
    ".wfm-subtitle": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
      fontSize: "13px",
      lineHeight: "20px",
      color: "var(--color-text-light, #666666)",
      margin: 0,
    },
  };
});

export const CloseButton = styled.button(() => {
  return {
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "var(--color-button-secondary, #f3f4f6)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    padding: 0,
    color: "var(--color-text, #333333)",
    fontSize: "16px",
    transition: "background-color 0.15s ease, transform 0.15s ease",
    "&:hover": {
      backgroundColor: "var(--color-button-secondary-hover, #eaedf2)",
      transform: "scale(1.05)",
    },
    "&:active": {
      transform: "scale(0.95)",
    },
  };
});

export const FormGroup = styled.div(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  };
});

export const FormLabel = styled.label(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
    color: "var(--color-label, #00838f)",
    letterSpacing: "0.02em",
  };
});

export const FormInput = styled.input(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "var(--color-text, #333333)",
    padding: "10px 14px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    width: "100%",
    boxSizing: "border-box",
    outline: "none",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    "&:focus": {
      borderColor: "var(--color-secondary, #1976d2)",
      boxShadow: "0 0 0 3px rgba(25,118,210,0.12)",
    },
    "&::placeholder": {
      color: "#999999",
    },
    "&:disabled": {
      backgroundColor: "#f3f4f6",
      cursor: "not-allowed",
    },
  };
});

export const AmountInputWrapper = styled.div(() => {
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    ".wfm-currency-symbol": {
      position: "absolute",
      left: "14px",
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
      fontSize: "14px",
      color: "var(--color-text-light, #666666)",
      pointerEvents: "none",
      zIndex: 1,
    },
    ".wfm-amount-input": {
      paddingLeft: "28px",
    },
  };
});

export const HelperText = styled.p(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    color: "var(--color-text-light, #666666)",
    margin: 0,
  };
});

export const ModalFooter = styled.div(() => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
    paddingTop: "4px",
  };
});

export const CancelButton = styled.button(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: "var(--color-text, #333333)",
    backgroundColor: "var(--color-button-secondary, #f3f4f6)",
    border: "none",
    borderRadius: "8px",
    padding: "0 20px",
    height: "44px",
    cursor: "pointer",
    transition: "background-color 0.15s ease, transform 0.15s ease",
    "&:hover": {
      backgroundColor: "var(--color-button-secondary-hover, #eaedf2)",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
  };
});

export const ContinueButton = styled.button(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#ffffff",
    backgroundColor: "var(--color-primary, #2e7d32)",
    border: "none",
    borderRadius: "8px",
    padding: "0 20px",
    height: "44px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    minWidth: "120px",
    transition: "background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
      backgroundColor: "#256427",
      boxShadow: "0 2px 8px rgba(46,125,50,0.25)",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
  };
});

export const ErrorText = styled.p(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: "13px",
    lineHeight: "18px",
    color: "#dc2626",
    margin: 0,
  };
});

export const SuccessBadge = styled.div(() => {
  return {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    backgroundColor: "var(--color-primary-hover, #2e7d3225)",
    border: "2px solid rgba(46,125,50,0.25)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    margin: "0 auto",
    svg: {
      width: "28px",
      height: "28px",
    },
  };
});

export const Step2Header = styled.div(() => {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    textAlign: "center",
    ".wfm-step2-title": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 700,
      fontSize: "18px",
      lineHeight: "24px",
      color: "var(--color-text, #333333)",
      margin: 0,
    },
    ".wfm-step2-subtitle": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
      fontSize: "13px",
      color: "var(--color-text-light, #666666)",
      margin: 0,
    },
  };
});

export const SectionLabel = styled.p(() => {
  return {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "11px",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "var(--color-label, #00838f)",
    margin: "4px 0 0",
  };
});

export const DetailRow = styled.div(() => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 0",
    borderBottom: "1px solid #f0f0f0",
    ".wfm-detail-label": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
      fontSize: "13px",
      color: "var(--color-text-light, #666666)",
    },
    ".wfm-detail-value": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      fontSize: "13px",
      color: "var(--color-text, #333333)",
      textAlign: "right",
    },
    "&:last-child": {
      borderBottom: "none",
    },
  };
});

export const TotalRow = styled.div(() => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px",
    backgroundColor: "var(--color-primary-hover, #2e7d3225)",
    borderRadius: "8px",
    marginTop: "8px",
    ".wfm-total-label": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      fontSize: "14px",
      color: "var(--color-text, #333333)",
    },
    ".wfm-total-value": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 700,
      fontSize: "16px",
      color: "var(--color-primary, #2e7d32)",
    },
  };
});

export const StatusPill = styled.span(() => {
  return {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "100px",
    padding: "3px 10px",
    backgroundColor: "rgba(0,131,143,0.10)",
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "12px",
    color: "var(--color-tertiary, #00838f)",
    letterSpacing: "0.01em",
  };
});
